const options = [
  {
    value: '1',
    label: 'Option 1',
  },
  {
    value: '2',
    label: 'Option 2',
  },
];

const formConfig = {
  templates: [
    {
      name: 'Description',
      title: 'Template Name',
    },
    {
      name: 'InvoiceAttention',
      title: 'Invoice Attention',
    },
    {
      name: 'SubmissionTypeId',
      title: 'Submission Type',
    },
    {
      name: 'ProjectNumber',
      title: 'Project #',
    },
    {
      name: 'ReportAttention',
      title: 'Report Attention',
    },
    {
      name: 'ClientNumber',
      title: 'Client',
    },
    {
      name: 'SiteLocationOrSiteNumber',
      title: 'Site Location / Site #',
    },
    {
      name: 'CreatedByName',
      title: 'Created By',
    },
    {
      name: 'DateType',
      title: 'Date Type',
    },
    {
      name: 'POAFENumber',
      title: 'PO #',
    },
    {
      name: 'ModifiedByName',
      title: 'Modified By',
    },
    {
      name: 'DateFrom',
      title: 'From',
    },
    {
      name: 'DateTo',
      title: 'To',
    },
    {
      selectNumberNine: [
        {
          label: 'Created Date',
          value: 'createdDate',
        },
        {
          label: 'Modified Date',
          value: 'modified Date',
        },
      ],
      selectNumberSix: [
        {
          label: 'Select All',
          value: 'selectAll',
        },
        {
          label: 'Balance Due',
          value: 'balanceDue',
        },
        {
          label: 'Paid',
          value: 'paid',
        },
      ],
    },
  ],
  supplies: [
    {
      name: 'OrderNumber',
      title: 'Order #',
    },
    {
      name: 'InvoiceToAttention',
      title: 'Invoice Attention',
    },
    {
      name: 'SubmissionTypeId',
      title: 'Submission Type',
    },
    {
      name: 'ProjectNumber',
      title: 'Project #',
    },
    {
      name: 'ReportToAttention',
      title: 'Report Attention',
    },
    {
      name: 'ClientNumber',
      title: 'Client',
    },
    {
      name: 'SiteLocationOrSiteNumber',
      title: 'Site Location / Site #',
    },
    {
      name: 'CreatedBy',
      title: 'Ordered By',
    },
    {
      name: 'DateType',
      title: 'Date Type',
    },
    {
      name: 'POAFENumber',
      title: 'PO #',
    },
    {
      name: 'WayBill',
      title: 'Waybill',
    },
    {
      name: 'DateFrom',
      title: 'From',
    },
    {
      name: 'DateTo',
      title: 'To',
    },
    {
      selectNumberNine: [
        {
          label: 'Date Ordered',
          value: 'dateOrdered',
        },
        {
          label: 'Date Shipped',
          value: 'dateShipped',
        },
        {
          label: 'Date Required',
          value: 'dateRequired',
        },
      ],
      selectNumberSix: [
        {
          label: 'Select All',
          value: 'selectAll',
        },
        {
          label: 'Balance Due',
          value: 'balanceDue',
        },
        {
          label: 'Paid',
          value: 'paid',
        },
      ],
    },
  ],
  invoices: [
    {
      name: 'InvoiceNumber',
      title: 'Invoice #',
    },
    {
      name: 'MaxxamJobNumber',
      title: 'Job #',
    },
    {
      name: 'SubmissionTypeId',
      title: 'Submission Type',
    },
    {
      name: 'ProjectNumber',
      title: 'Project #',
    },
    {
      name: 'InvoiceAttention',
      title: 'Invoice Attention',
    },
    {
      name: 'Paid',
      title: 'Status',
    },
    {
      name: 'SiteLocationOrSiteNumber',
      title: 'Site Location / Site #',
    },
    {
      name: 'ReportAttention',
      title: 'Report Attention',
    },
    {
      name: 'ClientNumber',
      title: 'Client',
    },
    {
      name: 'POAFENumber',
      title: 'PO #',
    },
    {
      name: 'TaskOrderNumber',
      title: 'Task Order #',
    },
    {
      name: 'DateFrom',
      title: 'Invoiced From',
    },
    {
      name: 'DateTo',
      title: 'Invoiced To',
    },
    {
      selectNumberSix: [
        {
          label: 'Select All',
          value: 'selectAll',
        },
        {
          label: 'Balance Due',
          value: 'balanceDue',
        },
        {
          label: 'Paid',
          value: 'paid',
        },
      ],
      selectNumberNine: [
        {
          label: 'Created Date',
          value: 'createdDate',
        },
        {
          label: 'Modified Date',
          value: 'modified Date',
        },
      ],
    },
  ],
  jobs: [
    {
      name: 'SampleID',
      title: 'Your Sample ID',
    },
    {
      name: 'MaxxamJobNumber',
      title: 'Job #',
    },
    {
      name: 'SubmissionTypeId',
      title: 'Submission Type',
    },
    {
      name: 'MaxxamSampleNumber',
      title: 'Sample #',
    },
    {
      name: 'ECoCNumber',
      title: 'eCOC #',
    },
    {
      name: 'Status',
      title: 'Status',
    },
    {
      name: 'ProjectNumber',
      title: 'Project #',
    },
    {
      name: 'CoCNumber',
      title: 'COC #',
    },
    {
      name: 'ClientNumber',
      title: 'Client',
    },
    {
      name: 'SiteLocationOrSiteNumber',
      title: 'Site Location / Site #',
    },
    {
      name: 'Attention',
      title: 'Attention',
    },
    {
      name: 'DateType',
      title: 'Date Type',
    },
    {
      name: 'POAFENumber',
      title: 'PO #',
    },
    {
      name: 'invoiceNumber',
      title: 'Invoice #',
    },
    {
      name: 'DateFrom',
      title: 'From',
    },
    {
      name: 'DateTo',
      title: 'To',
    },
    {
      name: 'AdditionNumber',
      title: 'Addition #',
    },
    {
      dateType: [
        {
          label: 'Received Date',
          value: 'receivedDate',
        },
        {
          label: 'Sampling Date',
          value: 'samplingDate',
        },
        {
          label: 'Job Due Date',
          value: 'jobDueDate',
        },
        {
          label: 'Submitted Date',
          value: 'modifiedDate',
        },
      ],
      selectNumberSix: [
        {
          label: 'Select All',
          value: 'selectAll',
        },
        {
          label: 'Draft',
          value: 'draft',
        },
        {
          label: 'Submitted',
          value: 'submitted',
        },
        {
          label: 'Cancelled',
          value: 'cancelled',
        },
        {
          label: 'Received',
          value: 'received',
        },
        {
          label: 'Entered',
          value: 'entered',
        },
        {
          label: 'In Progress',
          value: 'inProgress',
        },
        {
          label: 'Complete',
          value: 'complete',
        },
      ],
      selectNumberNine: [
        {
          label: 'Created Date',
          value: 'createdDate',
        },
        {
          label: 'Modified Date',
          value: 'modified Date',
        },
      ],
    },
  ],
};

const initialFormData = {
  Description: '',
  InvoiceAttention: '',
  SubmissionTypeId: '',
  ProjectNumber: '',
  ReportAttention: '',
  ClientNumber: '',
  SiteLocationOrSiteNumber: '',
  CreatedByName: '',
  DateType: '',
  POAFENumber: '',
  ModifiedByName: '',
  DateFrom: '',
  DateTo: '',
  OrderNumber: '',
  CreatedBy: '',
  WayBill: '',
  InvoiceNumber: '',
  MaxxamJobNumber: '',
  Status: '',
  TaskOrderNumber: '',
  SampleID: '',
  ECoCNumber: '',
  CoCNumber: '',
  invoiceNumber: '',
  MaxxamSampleNumber: '',
  Attention: '',
  AdditionNumber: '',
};


const searchType = [
  {
    label: 'Jobs & Samples',
    value: 'jobs',
  },
  {
    label: 'eCOC Templates',
    value: 'templates',
  },
  {
    label: 'Supplies',
    value: 'supplies',
  },
  {
    label: 'Invoices',
    value: 'invoices',
  },
];

export default {
  initialFormData,
  options,
  formConfig,
  searchType,
};



// WEBPACK FOOTER //
// ./src/constants/search.js